import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import EntriesProduct from 'components/EntriesProduct'
import headerImg from 'images/entries/header-entries.jpg'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar, filters } from '../Styles'
const EntriesScreen = props => {
  const data = props.entriesData

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Entradas</Typography>
          </div>
          <div className="right">
            <Hidden xsDown>
              <DownloadIcon className={props.classes.goBackIcon} onClick={props.downloadEntriesCsv} />
            </Hidden>
          </div>
        </Toolbar>
      )}>
      <div className={props.classes.header}>
        <Grid container direction="column" className={props.classes.header1}>
          <Grid item>
            <Typography className={props.classes.totalKg}>
              {!data ? (
                <CircularProgress color="secondary" />
              ) : (
                data.netWeightGlobal.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' kg.'
              )}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={props.classes.totalEntries}>
              <b>{data ? data.numEntriesGlobal : '--'}</b> partidas en <b>{data ? data.numDeliveriesGlobal : '--'}</b>{' '}
              albaranes
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="column">
          <Grid item container className={props.classes.filters}>
            <Grid item xs={4} onClick={props.openDateModal}>
              <Typography className={props.classes.filterName}>
                Periodo
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography
                className={props.classes.filterValue}
                dangerouslySetInnerHTML={{ __html: props.periodLabel }}
              />
            </Grid>
            <Grid item xs={4} onClick={props.openGreenhousesModal}>
              <Typography className={props.classes.filterName}>
                Naves
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography className={props.classes.filterValue}>
                {props.selectedGreenhouses.length ? `${props.selectedGreenhouses.length} seleccionadas` : 'Todas'}
              </Typography>
            </Grid>

            <Grid item xs={4} onClick={props.openFarmerModal}>
              <Typography className={props.classes.filterName}>
                Agricultor
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography className={props.classes.filterValue}>
                {props.selectedFarmers.length ? `${props.selectedFarmers.length} seleccionadas` : 'Todas'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Grid container className={props.classes.products}>
        {data &&
          data.entries &&
          data.entries.map((data, index) => (
            <EntriesProduct
              key={index}
              data={data}
              loadSampledEntry={props.loadSampledEntry}
              onSelectEntryProduct={props.onSelectEntryProduct}
            />
          ))}
      </Grid>
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  header: {
    backgroundImage: `url('${headerImg}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
  },
  header1: {
    padding: 10,
  },
  totalKg: {
    marginTop: 17,
    fontSize: 40,
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'center',
  },
  totalEntries: {
    marginTop: 10,
    marginBottom: 10,
    fontSize: 15,
    fontWeight: 300,
    color: 'white',
    textAlign: 'center',
  },
  filters: {
    padding: 7,
    ...filters,
  },
  filterName: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 300,
    fontSize: 13,
    cursor: 'pointer',
  },
  filterValue: {
    marginTop: -3,
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
    cursor: 'pointer',
  },
  products: {},
}

export default withStyles(styles)(EntriesScreen)



// WEBPACK FOOTER //
// ./src/screens/EntriesScreen.js